import React from 'react'
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';

export default function PaymentMethodRazorPayConfigurationComponent({
  handleInnerFormChange, selectRazorpay
}: any) {

  return (
    <>
      <AccordionContainer
        child={
          <div className='grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
            <InputContainer
              label="Gateway Name"
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'RazorPay.GatewayName',
                  selectRazorpay?.RazorPay
                );
              }}
              type="text"
              value={selectRazorpay?.RazorPay?.GatewayName}
            />
            <InputContainer
              label="Gateway Key"
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'RazorPay.GatewayKey',
                  selectRazorpay?.RazorPay
                );
              }}
              type="text"
              value={selectRazorpay?.RazorPay?.GatewayKey}
            />
            <InputContainer
              label="Gateway Secret"
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'RazorPay.GatewaySecret',
                  selectRazorpay?.RazorPay
                );
              }}
              type="text"
              value={selectRazorpay?.RazorPay?.GatewaySecret}
            />
            <InputContainer
              label="Active"
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event,
                  'RazorPay.IsActive',
                  selectRazorpay?.RazorPay
                );
              }}
              type="checkbox"
              value={selectRazorpay?.RazorPay?.IsActive}
            />
          </div>
        }
        expandedPanel="RazorPay Configuration Info"
        headerTitle="RazorPay Information"
      />

    </>
  )
}